import { ReactNode } from "react";

export const CircleFull = (): ReactNode => {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="6" cy="6" r="5.5" fill="currentColor" stroke="currentColor" />
		</svg>
	);
};

export const CircleEmpty = (): ReactNode => {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="6" cy="6" r="5.5" stroke="currentColor" />
		</svg>
	);
};
